import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

if (environment.production && environment.sentry?.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment ?? 'production',
    tracesSampleRate: environment.sentry.tracesSampleRate ?? 1.0,
    sendDefaultPii: true,
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err) => console.error(err));
